import { useSelector } from "react-redux";
import { AgeFromDateString } from "age-calculator";
import PropTypes from "prop-types";

import RegistrationItem from "./RegistrationItem";
import CamperItemMenu from "./CamperItemMenu";
import { theme } from "../../styles";

import { Card } from "@mui/material";
import { CardHeader } from "@mui/material";
import { Avatar } from "@mui/material";
import { CardContent } from "@mui/material";

// displays camper info and their registrations in the cart
const CamperItem = ({ camper }) => {
  const registrations = useSelector((state) =>
    state.cart.registrations.filter((reg) => reg.camperKey === camper.key)
  );
  const programType = useSelector((state) => state.account.programType);

  const initials = camper.firstName.charAt(0) + camper.lastName.charAt(0);
  const fullName = `${camper.firstName} ${camper.lastName}`;
  const bioDetails = `${camper.sex} - Age: ${
    new AgeFromDateString(camper.birthdate).age
  }`;

  return (
    <Card>
      <CardHeader
        avatar={
          <Avatar
            aria-label="camper"
            sx={{
              backgroundColor: `${theme.palette.primary.main}`,
              width: "40px",
              height: "40px",
            }}
          >
            {initials}
          </Avatar>
        }
        action={<CamperItemMenu camper={camper} />}
        title={fullName}
        subheader={bioDetails}
        sx={{ padding: "16px 8px", cursor: "default" }}
      />
      <CardContent sx={{ padding: "0", "&:last-child": { paddingBottom: 0 } }}>
        {registrations
          .filter((reg) => reg.programType.includes(programType))
          .map((reg) => (
            <RegistrationItem
              key={reg.key}
              camper={camper}
              registration={reg}
            />
          ))}
      </CardContent>
    </Card>
  );
};

CamperItem.propTypes = {
  camper: PropTypes.object.isRequired,
};

export default CamperItem;
